export default "__VITE_PUBLIC_ASSET__3f7c66b4__"